<section class="container">
  <header class="header">{{ 'Menu.items.devices' | translate }}</header>
  <div class="redline"></div>
  <span class="text">{{ 'Common.Devices.description' | translate }}</span>
  <app-connected-devices></app-connected-devices>
  <div>
    <!-- Commented out as per original -->
    <!-- <app-device-list
      [title]="'Common.Devices.activeDevices' | translate"
      [count]="3"
      [list]="[{
        os: 'test',
        version: '123',
        time: '2024/10/31',
        status: ''
      }]"
      [config]="[]">
    </app-device-list> -->
  </div>
  <div>
    <!-- <app-device-list
      [title]="'Common.Devices.blockedDevices' | translate"
      [count]="1"
      [list]="[{
        os: '',
        version: '',
        time: '',
        status: ''
      }]"
      [config]="[]">
    </app-device-list> -->
  </div>
</section>